// extracted by mini-css-extract-plugin
module.exports = {"video":"SectionOne_video__3425O","bbb":"SectionOne_bbb__3kjTV","button":"SectionOne_button__2t7b0","btn":"SectionOne_btn__3IfSj"};